import { render, staticRenderFns } from "./OrgManage.vue?vue&type=template&id=609d3124&scoped=true"
import script from "./OrgManage.vue?vue&type=script&lang=js"
export * from "./OrgManage.vue?vue&type=script&lang=js"
import style0 from "./OrgManage.vue?vue&type=style&index=0&id=609d3124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d3124",
  null
  
)

export default component.exports